var React = require('react');

function WhyDigitalBackgroundTop3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M380 42C48.4876 42 0 40.585 0 0V72V82H800V72C800 39.3968 742.894 39.8158 548.566 41.2416C500.993 41.5906 445.196 42 380 42Z","fill":"#3290FF"}));
}

WhyDigitalBackgroundTop3.defaultProps = {"width":"800","height":"82","viewBox":"0 0 800 82","preserveAspectRatio":"none","fill":"none"};

module.exports = WhyDigitalBackgroundTop3;

WhyDigitalBackgroundTop3.default = WhyDigitalBackgroundTop3;
